import React from "react";

export default function About() {
  return (
    <div>
      <h1>About This App</h1>
      <p>Search github users and stuff</p>
      <p>2020</p>
    </div>
  );
}
